/**
 * Composes single-argument functions from right to left.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left.
 */
export default (function () {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.length === 0 ? function (arg) {
    return arg;
  } : function () {
    return funcs.reduceRight(function (acc, elm, index) {
      return index < funcs.length - 1 ? elm(acc) : acc;
    }, funcs[funcs.length - 1].apply(funcs, arguments));
  };
});